import { instance } from '../instance'

/**
 * Delete user data
 *
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export const deleteUser = async (data = {}) => {
  return instance.delete('/v2/user', data)
}
